import { Breadcrumbs, Container, Link, Stack } from "@mui/material";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import Typography from '@mui/material/Typography';
import MenuMenu from "./MenuMenu";
// import icon_batsu from "../images/batsu.svg";
// import icon_sankaku from "../images/sankaku.svg";
// import icon_maru from "../images/maru.svg";
// import icon_minus from "../images/icon_minus.png";
// import icon_hatena from "../images/hatena.svg";
// import icon_bikkuri from "../images/bikkuri.svg";
// import img_beginners1 from "../img/beginners1.png";
// import img_beginners2 from "../img/beginners2.png";
// import img_beginners3 from "../img/beginners3.png";
import { useEffect, useRef, useState } from "react";
import parse from 'html-react-parser';
import axios from "axios";
import { API } from "./constantsFront";

/**
 * 初めての方へ
 * @returns 
 */
const D006FirstTime = () => {
  const [firstDetail, setFirstDetail] = useState("");
  let body = { authKey: API.API_KEY };
  const preview = localStorage.getItem("firstpreview");
  let previewdata = JSON.parse(preview);
  localStorage.removeItem("firstpreview");

  const refIsFirst = useRef(true);
  useEffect(() => {
    //初回読込チェック
    if (!refIsFirst.current) {
      return;
    }

    if (!previewdata) {
      //DBの内容を表示
      axios.post("/m_first_time/select/publish", body).then(res => {
        let first = res.data.first
        setFirstDetail(parse(first[0].content))
      })
    } else {
      //プレビュー表示
      setFirstDetail(parse(previewdata.content))
    }

    //初回読込フラグをfalseにセット
    refIsFirst.current = false;
  })

  return (
    <>

      <MenuMenu sel={0} />
      <div id="homeContents">
        <div class="homeContentsInner">
          <div class="mainCont">
            <div class="selectSearchArea">

              <Container maxWidth="lg" style={{ paddingLeft: "0", paddingRight: "0" }}>
                <Stack spacing={2}>
                  <Breadcrumbs
                    separator={<NavigateNextIcon fontSize="small" />}
                    aria-label="breadcrumb"
                  >
                    <Link underline="hover" key="1" color="inherit" href="./" style={{ fontSize: "14px" }}>
                      TOP
                    </Link>,
                    <Typography key="2" color="text.primary" style={{ fontSize: "14px" }}>
                      初めての方へ
                    </Typography>
                  </Breadcrumbs>

                  <h1>初めての方へ</h1>

                  {firstDetail}

                  {/* 本サイトでは、農林水産物・食品の輸出を検討されている方が、輸出先国・地域の輸入規制の有無や、規制の概要について照会できます。 */}
                  {/* <div>本サイトでは、農林水産物・食品の輸出を検討されている方が、各国・地域への輸出の可否や要件・規制の概要について照会できます。</div>

                  <p class="table-title">サイトご利用の流れ</p>

                  <div style={{ fontWeight: "700" }}>１．対象の品目に、輸出可能または不可能な規制があるかを調べます。</div>

                  <Stack spacing={2}
                    direction={{ xs: 'column', md: 'row' }}
                    style={{ width: "100%", display: "flex", justifyContent: "space-evenly" }}>
                    <div style={{ flexDirection: "column", textAlign: "center", position: "relative" }}>
                      <img src={img_beginners1} style={{ width: "300px" }}></img>
                      <span style={{ position: "absolute", bottom: "15px", left: "54px", fontWeight: "700", color: "#8B331A" }}>
                        品目を入力してください※
                      </span>
                    </div>

                    <div style={{ flexDirection: "column", textAlign: "center", position: "relative" }}>
                      <img src={img_beginners2} style={{ width: "300px" }}></img>
                      <span style={{ position: "absolute", bottom: "15px", left: "48px", fontWeight: "700", color: "#8B331A" }}>
                        輸出先国を入力してください
                      </span>
                    </div>

                    <div style={{ flexDirection: "column", textAlign: "center", position: "relative" }}>
                      <img src={img_beginners3} style={{ width: "300px" }}></img>
                      <span style={{ position: "absolute", bottom: "15px", left: "72px", fontWeight: "700", color: "#8B331A" }}>
                        簡易輸出判定が出ます
                      </span>
                    </div>
                  </Stack>
                  <div>

                    <div style={{
                      backgroundColor: "#EDEEF2"
                      , padding: "20px 30px 20px 30px"
                      , marginTop: "16px"
                    }}>
                      <div style={{ fontWeight: "700" }}>※本サイトで取り扱う品⽬について</div>
                      <div style={{ marginTop: "16px" }}>農林水産物や加工食品について検索が可能です。なお、規制・措置により検索可能な品目は異なります。</div>
                      <table bordercolor="gainsboro" style={{ marginTop: "16px" }}>
                        <tbody class="table-body">
                          <tr>
                            <td style={{ backgroundColor: "#1B335E", color: "white", padding: "10px", width: "30%" }}>
                              検索できる品⽬例
                            </td>
                            <td style={{ backgroundColor: "white", padding: "10px" }}>
                              りんご、かぼちゃ、⽜⾁のような、農林⽔産物（一次産品）。EU食品添加物データベース検索ページからは加⼯食品も検索可。</td>
                          </tr>
                          <tr>
                            <td style={{ backgroundColor: "#1B335E", color: "white", padding: "10px" }}>
                              検索できない品⽬例</td>
                            <td style={{ backgroundColor: "white", padding: "10px" }}>
                              中古農業機械、⾞、スポーツ⽤品のような、農林⽔産物や食品でないもの。農林水産物や食品であっても「シャインマスカット」のような品種名、「晴王」のようなブランド名、「冷凍フルーツ大福」のような商品名。</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div style={{ fontWeight: "700" }}>２．対象の品目に関する規制を確認します。</div>
                  <div>
                    植物検疫、動物検疫、放射性物質、残留農薬、食品添加物の５つの要件・規制を参照いただけます。
                  </div>

                  <div>
                    <div style={{ fontWeight: "700", color: "#1B335E" }}>当サイトでの輸出可否判定と規制の表記</div>
                    <table bordercolor="gainsboro">
                      <tbody class="table-body">

                        <tr>
                          <td class="judge-td" style={{ backgroundColor: "#EDEEF2", width: "30%" }}>
                            <div class="kigou"><img src={icon_maru} /></div>
                            <div >輸出可</div>
                          </td>
                          <td style={{ padding: "10px" }}>
                            輸出先国・地域が、放射性物質規制を適用していない、植物検疫、動植物検疫に関する検査・証明書の添付を求めていない場合を指します。
                          </td>
                        </tr>
                        <tr>
                          <td class="judge-td" style={{ backgroundColor: "#EDEEF2" }}>
                            <div class="kigou"><img src={icon_sankaku} /></div>
                            <div>輸出可（条件あり）</div>
                          </td>
                          <td style={{ padding: "10px" }}>
                            輸出先国・地域が、一部の品目・地域に対して放射性物質規制を適用している、植物検疫、動植物検疫に関する検査・証明書の添付を求めている場合を指します。
                          </td>
                        </tr>
                        <tr>
                          <td class="judge-td" style={{ backgroundColor: "#EDEEF2" }}>
                            <div class="kigou"><img src={icon_batsu} /></div>
                            <div>輸出不可</div>
                          </td>
                          <td style={{ padding: "10px" }}>
                            輸出先国・地域が、放射性物質規制、植物検疫、動植物検疫措置のいずれか、もしくは、複数の規制により輸出ができない場合を指します。
                          </td>
                        </tr>
                        <tr>
                          <td class="judge-td" style={{ backgroundColor: "#EDEEF2" }}>
                            <div class="kigou"><img src={icon_bikkuri} /></div>
                            <div>要確認</div>
                          </td>
                          <td style={{ padding: "10px" }}>
                            残留農薬と食品添加物については、各国・地域の条件をご確認ください。
                          </td>
                        </tr>
                        <tr>
                          <td class="judge-td" style={{ backgroundColor: "#EDEEF2" }}>
                            <div class="kigou"><img src={icon_hatena} /></div>
                            <div>判定不可</div>
                          </td>
                          <td style={{ padding: "10px" }}>
                            輸出できるかどうかの情報を把握していない場合を指します。
                          </td>
                        </tr>

                      </tbody>
                    </table>
                  </div>
                  <div>※輸出可否の判定基準に、残留農薬規制、食品添加物規制は含まれません。確認事項のご案内のみとしております。</div>

                  <div style={{ fontWeight: "700" }}>３.「残留農薬基準値検索」「EU食品添加物データベース」では一部の国・地域について詳細情報を提供しております。</div>
                  <div>
                    残留農薬基準値検索では、15品目×20ゕ国・地域及び国際基準の農薬基準値が検索できます。EU食品添加物データベース検索では、EUの食品添加物の基準値が検索できます。あわせてご利⽤ください。
                  </div>

                  <div style={{
                    backgroundColor: "#FBECEB"
                    , padding: "20px 30px 20px 30px"
                  }}>
                    <div style={{ color: "red", fontSize: "11", display: "flex" }}>
                      <img src={icon_bikkuri} style={{ width: "20px" }} />
                      <div style={{ fontWeight: "700", marginLeft: "10px" }}>免責事項</div>
                    </div>
                    各国・地域の要件・規制は事前の周知なく変更されることがあり、
                    本サイトに掲載している情報と異なっている場合があります。
                    実際に輸出される際は、輸出先国・地域の輸入事業者を通じて最新の情報をご確認ください。
                    <br /><br />
                    本サイトの掲載情報の正確性については万全を期しておりますが、
                    農林⽔産省は利⽤者が本サイトの情報を⽤いて⾏う⼀切の⾏為について何ら責任を負うものではありません。
                    <br /><br />
                    本サイトは輸出の一次的検討をする際の参考としてください。輸出にあたっては相手国の一次情報を確認し相手国の輸入業者と相談するようにしてください。
                  </div> */}
                </Stack>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </>

  );
};

export default D006FirstTime;